import BasicRouterView from "../../../components/BasicRouterView.vue";

const catalogoWfRoutes = {
  path: "catalogo-wf",
  redirect: { name: "catalogo-wf-listagem" },
  meta: {
    label: "CatalogosWF",
    icon: "business",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "catalogo-wf-listagem",
      name: "catalogo-wf-listagem",
      meta: {
        label: "Listagem WF",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "biometria" */ "./views/ListagemWF.vue"),
    },
    {
      path: "catalogo-wf-gestao/:id",
      name: "catalogo-wf-gestao",
      meta: {
        label: "Gestão Catalogo WF",
        icon: "business",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "biometria" */ "./views/GestaoWF.vue"),
    },
    {
      path: "catalogo-wf-acompanhamento/:id",
      name: "catalogo-wf-acompanhamento",
      meta: {
        label: "Acompanhamento Catalogo WF",
        icon: "business",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "biometria" */ "./views/AcompanhamentoWF.vue"
        ),
    },
  ],
};

export default catalogoWfRoutes;
